<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>商品分类管理</el-breadcrumb-item>
            <el-breadcrumb-item>类型列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-input placeholder="请输入一级类别" clearable v-model="queryInfo.query" @clear="getInfoList()">
                        <el-button slot="append" icon="el-icon-search" @click="getInfoList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="3"><el-button icon="el-icon-plus" type="primary" @click=" addDialogVisible = true">添加商品类型</el-button></el-col>
            </el-row>
            
            <!--搜索与添加区域-->
            <!--列表区域-->
            <el-table :data="infolist" :key="infolist.index" height="600" style="width: 100%" stripe size="middle" default-expand-all row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

                <!-- <el-table-column label="ID" type="index"  width="50"></el-table-column> -->
                <el-table-column label="类别名称" prop="classname"  width="700"></el-table-column>
                <el-table-column label="排序" prop="orderid"  width="200"></el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="success" icon="el-icon-edit" size="mini" @click="EditInfo(scope.row.id)"></el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)"></el-button>
                            <el-button type="primary" icon="el-icon-plus" size="mini" v-if="scope.row.level < 3" @click="addDialogVisible1 = true; addForm1.pid = scope.row.id; addForm1.oneclassname = scope.row.classname;addForm1.level = scope.row.level+1"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加商品类型" :visible.sync="addDialogVisible" width="60%" top="50px" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px">
                    <el-form-item label="类型名称" prop="classname">
                        <el-input v-model="addForm.classname"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="orderid">
                        <el-input v-model="addForm.orderid"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button @click="AddInfo" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!-- 编辑对话框 -->
            <el-dialog title="编辑商品类型" :visible.sync="editDialogVisible" width="60%" top="50px" @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px">
                    <el-form-item label="类型名称" prop="classname">
                        <el-input v-model="editForm.classname"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="orderid">
                        <el-input v-model="editForm.orderid"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button @click="EditInfoSave" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑对话框 -->
      
            <el-dialog title="添加商品类型" :visible.sync="addDialogVisible1" width="60%" top="50px" @close="addDialogClosed1">
                <el-form :model="addForm1" :rules="addFormRules1" ref="addFormRef1"  label-width="100px">
                    <el-form-item label="一级类别" prop="classname">
                        <span style="color: #ccc;">{{addForm1.oneclassname}}</span>
                    </el-form-item>
                    <el-form-item label="类型名称" prop="classname">
                        <el-input v-model="addForm1.classname"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="orderid">
                        <el-input v-model="addForm1.orderid"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addDialogVisible1 = false">取 消</el-button>
                    <el-button @click="AddInfo1" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            infolist: [],
            addDialogVisible:false,
            addDialogVisible1:false,
            editDialogVisible:false,
            tag: false,
            //获取列表的参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            total: 0,
            //添加表单数据
            addForm:{
                pid:0,
                classname:'',
                level:1,
                orderid:0,
            },
            editForm: {},
            addForm1:{
                pid:'',
                oneclassname:'',
                classname:'',
                orderid:0,
            },
            //添加表单验证规则
            addFormRules:{
                classname:[
                    { required: true, message: '请输入类别名称', trigger: 'blur' }
                ]
            },
            editFormRules:{
                classname:[
                    { required: true, message: '请输入类别名称', trigger: 'blur' }
                ]
            },
            addFormRules1:{
                classname:[
                    { required: true, message: '请输入类别名称', trigger: 'blur' }
                ]
            },
            
        }
        
    },
    mounted(){
        this.getInfoList()   
    },
    methods:{
        async getInfoList() {
            const { data: res} = await this.$http.get('goodsclasslist/',{ params: this.queryInfo })

            if(res.status == 1 && res.data){
                const list = Array.isArray(res.data.list) ? res.data.list : []
                this.total = res.data.totalCount || 0
                this.infolist = list.map(v => v.fields || {})
                for (let index = 0; index < list.length; index++) {
                    this.infolist[index].id = list[index].pk
                }
            } else {
                this.total = 0
                this.infolist = []
            }
            
         },
        AddInfo(){
            this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                    const payload = {
                        ...this.addForm,
                        pid: Number(this.addForm.pid) || 0,
                        level: Number(this.addForm.level) || 1,
                        orderid: Number(this.addForm.orderid) || 0
                    }
                    const { data:res } = await this.$http.post('goodsclassadd/', payload)
                    if(res.status===0)
                    {
                        this.$message.success('信息添加成功！')
                        this.addDialogVisible = false
                        this.getInfoList()
                    }
            })
        },
        async EditInfo(id){
            const { data: res } = await this.$http.get('goodsclassinfo/' + id)
            this.editForm = res
            
            this.editDialogVisible = true
            
        },
        EditInfoSave(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const payload = {
                    ...this.editForm,
                    orderid: Number(this.editForm.orderid) || 0
                }
                const { data: res } = await this.$http.post('goodsclassedit/' + this.editForm.id, payload)
                if (res.status === 0) {
                    this.$message.success('信息修改成功')
                    this.editDialogVisible = false
                    this.getInfoList()
                }
            })
        },
        async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('goodsoneclassdel/'+ id)
            
                if (res.status === 0) { 
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getInfoList()
        },
        async AddInfo1(){
            this.$refs.addFormRef1.validate( async valid=>{
                if (!valid) return
                    const payload = {
                        ...this.addForm1,
                        pid: Number(this.addForm1.pid) || 0,
                        level: Number(this.addForm1.level) || 2,
                        orderid: Number(this.addForm1.orderid) || 0
                    }
                    const { data:res } = await this.$http.post('goodsclassadd/', payload)
                    if(res.status===0)
                    {
                        this.$message.success('信息添加成功！')
                        this.addDialogVisible1 = false
                        this.getInfoList()
                    }
            })
        },
        handleSizeChange(newSize){
            this.queryInfo.pagesize = newSize
            this.getInfoList()
        },
        handleCurrentChange(newPage){
            this.queryInfo.pagenum = newPage
            this.getInfoList()
        },
        addDialogClosed(){
                this.$refs.addFormRef.resetFields()
        },
        editDialogClosed(){
                this.$refs.editFormRef.resetFields()
        },
        addDialogClosed1(){
                this.$refs.addFormRef1.resetFields()
        },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    /deep/.el-dialog__body{
        padding-bottom:0px !important;
    }
</style>